<template>
  <pt-points-reward class="pt-points-reward__page"></pt-points-reward>
</template>

<script>
import PtPointsReward from 'cps/new-to-old-audit/pt-points-reward/withData'
export default {
  name: 'pt-points-reward__view',
  components: {
    'pt-points-reward': PtPointsReward
  }
}
</script>
